import { Country } from '../types/Country';
import { normalInstance } from './axiosInstance';

export const getCountries = async () => {
  return normalInstance.get<Country[]>('/countries');
};
